import loadable from '@loadable/component';

export const LazyLogoutPage = loadable(
  () =>
    import(
      /* webpackChunkName: "content/logout" */
      './LogoutPage'
    ),
);
